import {
  Card,
  Container as MuiContainer,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import styled from 'styled-components';
import { colors } from 'spw-theme';

export const Container = styled(MuiContainer)`
  &.MuiContainer-root {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 84px);
  }

  padding-bottom: 16px;
`;

export const Title = styled.h1`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 300;
  font-size: 32px;
  line-height: 34px;
  color: #${colors.black};
  margin: 9px 0 25px;

  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PreTableSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  && > * {
    margin-right: 16px;
  }
`;

export const ScrollableTableContainer = styled(TableContainer)<{
  $smallPaddingOnLastColumn?: boolean;
}>`
  flex: 1;
  overflow-y: scroll;

  .MuiTableCell-stickyHeader {
    background-color: ${colors.offWhite};
  }

  .MuiTableCell-head {
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;

    letter-spacing: 0.25px;
    text-transform: uppercase;

    color: ${colors.black};

    > div {
      display: flex;
      align-items: center;

      img {
        margin-left: 4px;
      }
    }
  }

  ${({ $smallPaddingOnLastColumn }) =>
    !$smallPaddingOnLastColumn
      ? `
  .MuiTableCell-root:last-child {
    padding-right: 45px;
  }
  `
      : ''}
  .MuiTableCell-head.MuiTableCell-alignRight {
    > div {
      display: flex;
      justify-content: end;
    }
  }

  .MuiTableSortLabel-root:hover {
    color: unset;
  }

  .MuiTableCell-body {
    padding: 10px 16px 9px;
    height: 51px;
    box-sizing: border-box;
  }

  .divider {
    padding-left: 24px;
    border-left: 1px solid ${colors.veryLightGray};
  }

  th.divider {
    border-left: 1px solid ${colors.sharedSpaces};
  }
`;

export const StyledTableRow = styled(TableRow)`
  &.highlighted {
    background-color: ${colors.grayLight};
  }
`;

export const ClickableRow = styled(StyledTableRow)`
  cursor: pointer;
`;

export const TeamsPopoverTrigger = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isActive', 'disabled'].includes(prop),
})<{ isActive: boolean; disabled?: boolean }>`
  ${({ isActive, disabled }) =>
    isActive || disabled
      ? `background-color: ${colors.lightGreyBackground};`
      : `border-radius: 50%;
         color: ${colors.mainBlue};
         cursor: pointer;
         
         &:hover {
           background-color: ${colors.lightGreyBackground};
         }`}
  align-items: center;
  background-color: transparent;
  display: flex;
  height: 32px;
  justify-content: center;
  margin-right: 0;
  transform: translateX(13px);
  width: 32px;
`;

export const TeamsPopoverCard = styled(Card)`
  padding: 16px 8px 16px 16px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 242px;
    overflow-y: auto;

    li > div {
      display: flex;
      align-items: center;
      width: max-content;
      cursor: pointer;

      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: ${colors.black};
      padding-right: 8px;

      .team-name {
        padding: 0 8px;
      }
    }

    li:not(:last-child) {
      margin-bottom: 8px;
    }
  }
`;

export const BorderlessCell = styled(TableCell)`
  &.MuiTableCell-root {
    border-bottom: 0;
    cursor: auto;
  }
`;

export const DetailInfo = styled.div`
  min-width: 130px;
  margin-right: 190px;
  margin-top: 40px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;

  .label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.mainGray};
  }

  .info {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
  }
`;
